import { Box, Button, CircularProgress } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import clsx from "clsx";
import { useStyles } from "../../../shared/styles/useStyles";

interface SubmitButtonProps {
  isLoading: boolean;
}

function SubmitButton({ isLoading }: SubmitButtonProps) {
  const classes = useStyles();

  return (
    <Box marginTop={"1rem"} display={"flex"} justifyContent={"end"}>
      <Button
        className={`${clsx(classes.btnAction, classes.save)} btn-send`}
        type="submit"
        disabled={isLoading}
      >
        {isLoading ? (
          <CircularProgress className={classes.btnLoading} />
        ) : (
          <FormattedMessage id="SendBtn" />
        )}
      </Button>
    </Box>
  );
}

export default SubmitButton;
